import { Button, Center } from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";
import React from "react";
import styles from "../../styles/About.module.css";


function resume() {
  window.open(
    "https://drive.google.com/file/d/11AT2gijQIE6jCS1Z-Q5lH8TIUnpmG1N3/view?usp=share_link",
    "_blank"
  );
}

const About = () => {
  
  return (
    <section className="about section" id="about">
      <div className={styles.aboutSection}>
        <h2>About</h2>
        <div className={styles.childAboutSection}>
          <h3 id="user-detail-intro">
            {" "}
            A passionate web developer who has more than 1200+ hours of
            practical knowledge in coding and is proficient in Node JS, React
            JS, JavaScript, CSS, HTML and GitHub. Looking to join an
            organization where he can show his skills and contribute to the
            organization.
          </h3>
          <Center>
            {/* <a href={"Charchit_Khandelwal_Resume.pdf"} download  id="resume-link-2">
              <Button
               id="resume-button-2"
              _hover={{backgroundColor:'white',color:'#0A536F'}}
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/11AT2gijQIE6jCS1Z-Q5lH8TIUnpmG1N3/view?usp=share_link"
                  )
                }
                mt={5}
                mb={5}
                backgroundColor="#0A536F"
                fontWeight="bold"
                letterSpacing="3px"
                color={"white"}
              >
                RESUME
                <DownloadIcon ml="9px" />
              </Button>
            </a> */}

            <Button id="resume-button-2" onClick={resume} backgroundColor="#0A536F"
                fontWeight="bold"
                letterSpacing="3px"
                color={"white"}>
              <a
                id="resume-link-2"
                href="Charchit_Khandelwal_Resume.pdf"
                download="Charchit_Khandelwal_Resume"
                target="_blank"
               
              >
                RESUME
              </a>
            </Button>
          </Center>
        </div>
      </div>
    </section>
  );
};

export default About;
